// @flow
import type {Node} from 'react'
import React from 'react'
import {QueryRenderer, graphql} from 'react-relay'

import environment from 'environment'
import {withErrorCheck} from 'decorators'
import Modal from './Modal'
import type {QueryVariables, Organization, Proposal} from './types'

const modalEditorQuery = graphql`
  query ProposalEditorQuery(
    $orgDatabaseId: String!,
    $proposalDatabaseId: String!,
  ) {
    organization(databaseId: $orgDatabaseId) {
      databaseId
      ...Builder_organization

      proposal(databaseId: $proposalDatabaseId) {
        id
        ...Modal_proposal
      }
    }
  }
`

type RendererProps = {
  organization: Organization,
}

type Props = {|
  orgDatabaseId: string,
  proposalDatabaseId: string,
  toggle: () => Promise<void>,
  noDeleteConfig: boolean,
|}

function ProposalEditor({orgDatabaseId, proposalDatabaseId, toggle, noDeleteConfig}: Props): Node {
  const rendererVariables: QueryVariables = {orgDatabaseId, proposalDatabaseId}

  const modalRenderer = ({organization}: RendererProps) => {
    if (!organization)
      return null

    const proposal: ?Proposal = organization.proposal

    if (!proposal)
      return null

    return (
      <Modal
        organization={organization}
        proposal={proposal}
        toggle={toggle}
        noDeleteConfig={noDeleteConfig}
      />
    )
  }

  const queryRenderer = withErrorCheck(modalRenderer)

  return (
    <QueryRenderer
      environment={environment}
      query={modalEditorQuery}
      render={queryRenderer}
      variables={rendererVariables}
    />
  )
}

ProposalEditor.defaultProps = {
  noDeleteConfig: false,
}

export default ProposalEditor
